import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import {
	SdfFocusPane,
	SdfIcon,
	SdfLink,
	SfcShellAppBarIcon,
} from '@waypoint/react-components';

const styles = {
	linkList: {
		paddingInlineStart: 0,
		listStyle: 'none',
	},
	linkListItem: {
		margin: '0 0 1rem 0',
		display: 'flex',
	},
};

const HelpLinksModal = (props) => {
	const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
	const useZoomChat = props.useZoomChat;

	const links = [
		...(useZoomChat
			? []
			: [
				{
					href: 'mailto:mysupport@workmarket.com',
					icon: 'action-email',
					text: 'mysupport@workmarket.com',
				},
			]),
		{
			href: 'tel:+1-917-877-9500',
			icon: 'phone',
			text: '917-877-9500',
		},
		{
			href: 'https://workmarket.zendesk.com/hc/en-us',
			icon: 'action-help',
			text: 'Help Center',
		},
		{
			href: 'http://status.workmarket.com',
			icon: 'status-flagged',
			text: 'Status Page',
		},
		{
			href: '/privacy',
			icon: null,
			text: 'Privacy statement',
		},
		{
			href: '/tos',
			icon: null,
			text: 'Terms of service',
		},
	];

	const handleChatClick = () => {
		if (window.zoomCampaignSdk) {
			window.zoomCampaignSdk.open();
			window.zoomCampaignSdk.show();
			window.zoomCampaignSdk.on('close', () => window.zoomCampaignSdk.hide());
		}
		setIsHelpModalOpen(false);
	};

	return (
		<React.Fragment>
			<SfcShellAppBarIcon
				data-attr-id="help-btn"
				slot="icons"
				icon="action-help"
				label="Help"
				onClick={() => { setIsHelpModalOpen(true); }}
			/>
			{createPortal(
				<SdfFocusPane
					data-attr-id="help-modal"
					closeable
					size="sm"
					visible={isHelpModalOpen}
					heading="Help"
					closeIconTitle="Close"
					onSdfDismiss={() => { setIsHelpModalOpen(false); }}
					hideAcceptButton
					hideDismissButton
				>
					<ul className="mx-8" style={styles.linkList}>
						{useZoomChat && (
							<li style={styles.linkListItem}>
								<SdfLink onClick={handleChatClick} onKeyPress={handleChatClick}>
									<SdfIcon icon="action-chat" className="mr-1" />
									Chat with us
								</SdfLink>
							</li>
						)}
						{links.map((link, idx) => (
							<li
								key={idx}
								style={styles.linkListItem}
								className={`${idx === 0 || idx === 2 ? 'pb-4 border-0 border-b-1 border-solid border-divider' : ''}`}
							>
								<SdfLink href={link.href}>
									{link.icon && (<SdfIcon icon={link.icon} className="mr-1" />)}
									{link.text}
								</SdfLink>
							</li>
						))}
					</ul>
				</SdfFocusPane>,
				document.body
			)}
		</React.Fragment>
	);
};

HelpLinksModal.propTypes = {
	useZoomChat: PropTypes.bool,
	useZendesk: PropTypes.bool,
};

export default HelpLinksModal;


// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/WaypointShellNav/HelpLinksModal.js